import React, { type ComponentProps } from 'react';
import { Label } from '@vibe/core';
import type { TimesheetStatus } from '../../types/timesheet-approval.types';

type LabelColor = ComponentProps<typeof Label>['color'];

/**
 * Color mapping aligned with BRD Section 15.2:
 * - Open (null): Gray - "Not Submitted"
 * - Submitted: Orange - "Pending Approval"
 * - Approved: Green - "Approved"
 * - Rejected: Red - "Rejected"
 * - Reopened: Purple - "Reopened"
 */
const STATUS_CONFIG: Record<string, { color: LabelColor; text: string }> = {
  open:      { color: Label.colors.DARK,           text: 'Not Submitted' },
  submitted: { color: Label.colors.WORKING_ORANGE, text: 'Pending Approval' },
  approved:  { color: Label.colors.POSITIVE,       text: 'Approved' },
  rejected:  { color: Label.colors.NEGATIVE,       text: 'Rejected' },
  reopened:  { color: Label.colors.PURPLE,         text: 'Reopened' },
};

export const TimesheetStatusBadge: React.FC<{
  status: TimesheetStatus | null;
}> = ({ status }) => {
  const config = STATUS_CONFIG[status ?? 'open'];
  return <Label text={config.text} color={config.color} />;
};
